/* eslint-disable */
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import {
  approveColours,
  coloursMasterList,
} from "../../Redux/Actions/MastersApprovalActions";
import { useDispatch, useSelector } from "react-redux";
import { OverlayTrigger } from "react-bootstrap";
import Swal from "sweetalert2";

const ColourMaster = ({ selectedTab, ApproveTooltip, DeleteTooltip }) => {
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState(null);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortColumnDir, setSortColumnDir] = useState(null);

  const loading = useSelector((state) => state.MastersApproval.coloursLoading);
  const colourMasterList = useSelector(
    (state) => state.MastersApproval.coloursMasterList
  );
  const noOfRecords = useSelector(
    (state) => state.MastersApproval.noOfRecordsColours
  );

  const getAllColoursMasterList = (
    page_number,
    page_size,
    sort_column_name,
    sort_column_dir,
    search_text
  ) => {
    const data = {
      page_number: page_number,
      page_size: page_size,
      sort_column_name: !!sort_column_name ? sort_column_name : null,
      sort_column_dir: !!sort_column_dir ? sort_column_dir : null,
      search_text: !!search_text ? search_text : null,
    };
    dispatch(coloursMasterList(data));
  };

  const handleSort = (column, sortDirection) => {
    if (Object.keys(column).length !== 0 && !!sortDirection) {
      setSortColumn(column.sortField);
      setSortColumnDir(sortDirection);
      getAllColoursMasterList(
        1,
        perPage,
        column.sortField,
        sortDirection,
        searchText
      );
    }
  };

  const handlePageChange = (page) => {
    setPage(page);
    getAllColoursMasterList(
      page,
      perPage,
      sortColumn,
      sortColumnDir,
      searchText
    );
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setPage(page);
    getAllColoursMasterList(
      page,
      newPerPage,
      sortColumn,
      sortColumnDir,
      searchText
    );
  };

  const approveColoursMaster = async (id, is_delete) => {
    const data = {
      id: id,
      is_delete: is_delete,
    };
    Swal.fire({
      title: "Are you sure?",
      html: `You want to ${is_delete ? "delete" : "approve"}!`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#000000",
      cancelButtonColor: "#dd3333",
      confirmButtonText: is_delete ? "Delete" : "Approve",
      customClass: {
        confirmButton: 'confirm-button-swal'
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        const res = await dispatch(approveColours(data));
        if (res.payload.result > 0) {
          getAllColoursMasterList(page, perPage, null, null, null);
          Swal.fire({
            title: res?.payload?.message,
            confirmButtonColor: "#000000",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: 'confirm-button-swal'
            }
          })
        } else {
          Swal.fire({
            title: res?.payload?.message,
            confirmButtonColor: "#000000",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: 'confirm-button-swal'
            }
          })
        }
      }
    });
  };

  useEffect(() => {
    if (!!selectedTab && selectedTab === "colour") {
      getAllColoursMasterList(page, perPage, null, null, searchText);
    }
  }, [selectedTab, searchText]);

  const customStylesDataTable = {
    headCells: {
      style: {
        fontSize: "16px",
        fontWeight: "Bold",
      },
    },
  };

  const columns = [
    {
      name: "Raw Colour",
      selector: (row) => row.rawColour,
      sortable: true,
      sortField: "RawColour",
    },
    {
      name: "Colour",
      selector: (row) => row.colour,
      sortable: true,
      sortField: "Colour",
    },
    {
      name: "Action",
      cell: (row) => (
        <>
        <div className={`actions`}>
          <OverlayTrigger placement="top" overlay={ApproveTooltip}>
            <button
              className="btn btn-sm bg-success-subtle"
              onClick={() => approveColoursMaster(row.id, false)}
            >
              <i className="bi bi-check2-circle"></i>
            </button>
          </OverlayTrigger>
          <OverlayTrigger placement="top" overlay={DeleteTooltip}>
            <button
              className="btn btn-sm bg-danger-subtle ms-2"
              onClick={() => approveColoursMaster(row.id, true)}
            >
              <i className="bi bi-trash"></i>
            </button>
          </OverlayTrigger>
          </div>
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];
  return (
    <div>
      <DataTable
        columns={columns}
        data={colourMasterList}
        className="table table-bordered table-striped"
        filterServer={true}
        pagination
        paginationServer
        paginationTotalRows={noOfRecords}
        subHeader
        subHeaderComponent={
          <div className="col-md-2">
            <input
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Search"
              className="form form-control"
            />
          </div>
        }
        progressPending={loading}
        progressComponent={
          <div style={{ padding: "100px" }}>
            <div className="spinner-border" role="status"></div>
          </div>
        }
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        sortServer
        onSort={handleSort}
        highlightOnHover
        searchableRows={true}
        customStyles={customStylesDataTable}
      />
    </div>
  );
};

export default ColourMaster;
